export default __webpack_public_path__ + "locales/az/Payments.json?hash=e0e8b55de9a3b20a853161019c1c36ef";